
import { Component, Vue } from 'vue-property-decorator'
import { ServiceChargeConfigService, ServiceChargeConfigDto } from '@/api/service-proxies'

@Component
export default class QRServiceChargeSetting extends Vue {
  private serviceChargeConfigService = new ServiceChargeConfigService()
  private rows: ServiceChargeConfigDto[] = []
  private queryParams = {
    tenantName: null
  }
  private editRow = new ServiceChargeConfigDto()
  private editDialogVisible = false
  private isLoading = false

  private mounted() {
    this.getAll()
  }
  
  private async getAll() {
    this.isLoading = true
    try {
      this.rows = await (await this.serviceChargeConfigService.getAll(this.queryParams.tenantName)).items
    } finally {
      this.isLoading = false
    }
  }

  private handleEdit(row: ServiceChargeConfigDto) {
    this.editRow = JSON.parse(JSON.stringify(row))
    this.editDialogVisible = true
  }

  private async handleConfirmEdit() {
    this.isLoading = true
    try {
      await this.serviceChargeConfigService.update(this.editRow)
      this.rows.find(x => x.id === this.editRow.id).annualCost = this.editRow.annualCost
      this.$message.success('保存成功')
      this.editDialogVisible = false
    } finally {
      this.isLoading = false
    }
  }
}
